import React from 'react';
import { bool, func, node, number, string, array, object } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import FilterComponent from '../FilterComponent';

import css from './MainPanelHeaderWithFilters.module.css';

const MainPanelHeaderWithFilters = props => {
  const {
    rootClassName,
    className,
    children,
    sortByComponent,
    isSortByActive,
    listingsAreLoaded,
    resultsCount,
    searchInProgress,
    noResultsInfo,
    availableFilters,
    marketplaceCurrency,
    urlQueryParams,
    initialValues,
    getHandleChangedValueFn,
    intl,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.searchOptions}>
        <div className={css.searchResultSummary}>
          <span className={css.resultsFound}>
            {searchInProgress ? (
              <FormattedMessage id="MainPanelHeader.loadingResults" />
            ) : (
              <FormattedMessage
                id="MainPanelHeader.foundResults"
                values={{ count: resultsCount }}
              />
            )}
          </span>
        </div>
        <div className={css.filtersRow}>
          {availableFilters.map(config => {
            return (
              <FilterComponent
                key={`SearchFiltersDesktop.${config.key}`}
                idPrefix="SearchFiltersDesktop"
                config={config}
                marketplaceCurrency={marketplaceCurrency}
                urlQueryParams={urlQueryParams}
                initialValues={initialValues}
                getHandleChangedValueFn={getHandleChangedValueFn}
                intl={intl}
                liveEdit
                showAsPopup={true}
                isDesktop
              />
            );
          })}
        </div>
        {isSortByActive ? (
          <div className={css.sortyByWrapper}>
            <span className={css.sortyBy}>
              <FormattedMessage id="MainPanelHeader.sortBy" />
            </span>
            {sortByComponent}
          </div>
        ) : null}
      </div>

      {children}

      {noResultsInfo ? noResultsInfo : null}
    </div>
  );
};

MainPanelHeaderWithFilters.defaultProps = {
  rootClassName: null,
  className: null,
  resultsCount: null,
  searchInProgress: false,
  sortByComponent: null,
  availableFilters: null,
  marketplaceCurrency: null,
  urlQueryParams: null,
  initialValues: null,
  getHandleChangedValueFn: null,
  intl: null,
};

MainPanelHeaderWithFilters.propTypes = {
  rootClassName: string,
  className: string,
  listingsAreLoaded: bool.isRequired,
  resultsCount: number,
  searchInProgress: bool,
  sortByComponent: node,
  availableFilters: array,
  marketplaceCurrency: string,
  urlQueryParams: object,
  initialValues: func.isRequired,
  getHandleChangedValueFn: func.isRequired,
  intl: object.isRequired,
};

export default MainPanelHeaderWithFilters;
